module.exports = __webpack_public_path__ + "img/DK21832278.303af8f6.png";